import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import image from "../../assets/images/suminimio-primilzio-paaiskinimo-lentele.png";

const SuminioPrimilzioPaaiskinimas = ({ isOpen, handleClose }) => {
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
      <Box>
        <DialogTitle sx={{ marginRight: 2 }}>Suminio primilžio paaiškinimas</DialogTitle>
      </Box>
      <Box sx={{ marginLeft: 2 }}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ marginTop: "-20px" }}>
        <Box display="flex" justifyContent="center">
          <img
            src={image}
            alt="Suminio primilžio paaiškinimo lentelė"
            style={{ width: "100%", height: "auto" }}
          />
        </Box>
        <Typography sx={{ fontWeight: "bold" }}>
          Vokiečių rekomenduojami vidutiniai pieno primilžiai, būdingi atskiriems laktacijos
          tarpsniams, atsižvelgiant į planuojamą gauti karvių pieno kiekį per 305 d. laktaciją.
        </Typography>
        <Typography>
          Pastaba: jei primilžiai bus mažesni, tikėtina, kad nebus planuojamos produkcijos per
          einamą ir kitas laktacijas. Atitinkamai reikės atskirų sprendimų, susijusių su karvių
          mityba, paveldimumu ir kitais faktoriais.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default SuminioPrimilzioPaaiskinimas;
